<section class="faq-section">
  <div class="faq-content">
    <!-- Header Section -->
    <div class="faq-header-row">
      <div class="faq-header">
        <div class="faq-head">
          <h2 class="faq-title">{{ title() | translateLang }}</h2>
          <div class="faq-eyebrow">
            <p class="faq-eyebrow-text">{{ eyebrow() | translateLang }}</p>
          </div>
        </div>
        <p class="faq-description">{{ description() | translateLang }}</p>
      </div>
      <app-button
        [label]="buttonText() | translateLang"
        [variant]="'yellow'"
        (clicked)="onButtonClick()()"
        class="faq-button">
      </app-button>
    </div>

    <!-- Mobile Button Placement -->
    <app-button
      [label]="buttonText() | translateLang"
      [variant]="'yellow'"
      (clicked)="onButtonClick()()"
      class="faq-mobile-button">
    </app-button>

    <!-- Accordion Section -->
    <div class="faq-body">
      <div class="faq-accordion">
        @for (item of faqItems(); track item.question; let i = $index) {
          <div
            class="faq-accordion-item"
            [class.expanded]="isExpanded(i)">
            <button
              class="faq-accordion-header"
              (click)="toggleFaq(i)"
              [attr.aria-expanded]="isExpanded(i)"
              [attr.aria-controls]="'faq-content-' + i">
              <p class="faq-question" [class.active]="isExpanded(i)">{{ item.question | translateLang }}</p>
              <div class="faq-chevron-container">
                <svg
                  class="faq-chevron"
                  [class.rotated]="isExpanded(i)"
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M6.25 9.375L12.5 15.625L18.75 9.375"
                    stroke="#96080B"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </div>
            </button>
            @if (isExpanded(i)) {
              <div
                [id]="'faq-content-' + i"
                class="faq-answer-container">
                <p class="faq-answer">{{ item.answer | translateLang }}</p>
              </div>
            }
            <div class="faq-divider"></div>
          </div>
        }
      </div>
    </div>
  </div>
</section>
